import MapMenuPopover            from '@/TokamapEditor/ux/MapMenu/MapMenuPopover';
import View                      from '@widesk-ui/components/View';
import { observer }              from 'mobx-react-lite';
import { EnvironmentOutlined }   from '@ant-design/icons';
import { DownOutlined }          from '@ant-design/icons';
import currentProjectEditorStore from '@/TokamapEditor/stores/currentProjectEditorStore';
import useDesignTokens           from '@/hooks/useDesignTokens';

// Segment gauche de la barre flottante (voir `MapFloatingControls`) : il porte le titre de la carte
// courante — qui ne vit plus dans la barre du haut, réservée au projet — et ouvre le menu des
// cartes. Pas de `Button` : le relief est porté par la barre, ce segment ne pose qu'un survol.
const MapButton = observer(() => {
	const projectEditor = currentProjectEditorStore.get;
	const tokens = useDesignTokens();

	const opened = projectEditor.mapMenuOpenedFrom === 'button';

	return (
		<MapMenuPopover source="button" placement="bottomRight">
			<View
				row
				centerV
				gap="xs"
				px="sm"
				h="100%"
				pointer
				color={tokens.text.default}
				bg={opened ? tokens.surface.subtle : undefined}
				hover={{ bg: tokens.surface.subtle }}
			>
				<EnvironmentOutlined style={{ color: tokens.color.primary, fontSize: 15 }} />

				<View
					bold
					style={{
						maxWidth: 220,
						whiteSpace: 'nowrap',
						overflow: 'hidden',
						textOverflow: 'ellipsis',
					}}
				>
					{projectEditor.currentMap.renderName()}
				</View>

				<DownOutlined
					style={{ fontSize: 10, opacity: 0.55, transition: 'transform .2s ease' }}
					rotate={opened ? 180 : 0}
				/>
			</View>
		</MapMenuPopover>
	);
});

export default MapButton;
